import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFloppyDisk2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFloppyDisk2"><Path d="M3.5 3.5H17.5L20.5 6.5V20.5H3.5V3.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M15.5 14.5C15.5 16.433 13.933 18 12 18C10.067 18 8.5 16.433 8.5 14.5C8.5 12.567 10.067 11 12 11C13.933 11 15.5 12.567 15.5 14.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M8.5 4V8.5H15.5V4" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconFloppyDisk2;
